import "swiper/swiper-bundle.css";
import { MetricsGrouping } from "./components/metrics-grouping/MetricsGrouping";
import { MetricsSlide } from "./components/metrics-slide/MetricsSlide";
import { Metrics } from "./Metrics";

export default Metrics;
export { MetricsSlide, MetricsGrouping };
